import { defineMessages } from "react-intl";

export const messages = defineMessages({
  manual: {
    id: "M59JhX",
    defaultMessage: "Manual",
  },
  manualDescription: {
    id: "83egc7",
    defaultMessage: "Manually enter the voucher code.",
  },
  autoGenerate: {
    id: "awNXI/",
    defaultMessage: "Auto-generate codes",
  },
  autoGenerateDescription: {
    id: "DJatYh",
    defaultMessage: "Generate multiple codes at once",
  },
  addCode: {
    id: "6xNl6V",
    defaultMessage: "Add code",
  },
});
